<mat-icon class="area-menu-icon" [svgIcon]="icon"></mat-icon>